"use client";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Utils from "../../utils/utmManager";
import { captureAttributionFromSearch } from "../../utils/attributionCapture";

const UTM = () => {
  const { search } = useLocation();

  useEffect(() => {
    Utils.utmManager(new URLSearchParams(search));
    captureAttributionFromSearch(search);
  }, [search]);

  return null;
};

export default UTM;
